class AnimatedButton extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('click', () => {
      const link = this.querySelector('a');
      const href = link.getAttribute('href');
      const target = link.getAttribute('target');

      if (href || !link.classList.contains('youtube-button')) {
        if (target === '_blank') {
          window.open(href, '_blank', 'noopener,noreferrer');
        } else {
          window.location.href = href;
        }
      }
    });
  }
}

customElements.define('animated-button', AnimatedButton);
